import React from 'react'
import classNames from 'classnames'

const Checkbox = ({ name, checked, onClick }) => {
	const checkboxClass = classNames(
		'checkbox',
		{'checkbox--checked': checked}
	)
	const checkmark = checked && (
		<svg version="1.1" className="checkbox__checkmark" x="0px" y="0px" viewBox="0 0 150 150">
			<path d="M17,75.8l33,33.4c0,0,1.4,1.6,2.5,1.6s2.6-1.6,2.6-1.6l68.4-67.8"/>
		</svg>
	)
	return (
		<div className={checkboxClass}>
			<label className="checkbox__label">
				<input
					className="checkbox__input"
					type="checkbox"
					name={name}
					checked={checked}
					onChange={(event) => onClick(event.target.checked, name)}
				/>
				{checkmark}
			</label>
		</div>
	)
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/js/Ui/Checkbox/Checkbox.jsx